import type {
  CreateProfileRequest,
  CreateProfileResponse,
  EditProfileRequest,
  EditProfileResponse,
  UserSettingsResponse,
} from '@mrb91002/shared-types'

import { secureFetch, SECURE_API_BASE } from './helpers'

/**
 * Create a new user profile (first sign-in)
 */
export async function createProfile(
  profileData: CreateProfileRequest,
  idToken: string,
): Promise<CreateProfileResponse> {
  return secureFetch<CreateProfileResponse>(`${SECURE_API_BASE}/user/profile`, idToken, {
    method: 'POST',
    body: JSON.stringify(profileData),
  })
}

/**
 * Update user profile (never allows editing screen_name)
 */
export async function updateProfile(profileData: EditProfileRequest, idToken: string): Promise<EditProfileResponse> {
  return secureFetch<EditProfileResponse>(`${SECURE_API_BASE}/user/profile`, idToken, {
    method: 'PUT',
    body: JSON.stringify(profileData),
  })
}

// uploadProfileImage is available via secure/images.ts unified upload

/**
 * Get user settings including craft room preferences
 */
export async function getUserSettings(idToken: string): Promise<UserSettingsResponse> {
  return secureFetch<UserSettingsResponse>(`${SECURE_API_BASE}/user/settings`, idToken, { method: 'GET' })
}

/**
 * Get detailed user settings
 */
export async function fetchUserSettingsDetailed(idToken: string): Promise<UserSettingsResponse> {
  return secureFetch<UserSettingsResponse>(`${SECURE_API_BASE}/user/settings`, idToken, { method: 'GET' })
}

/**
 * Update detailed user settings
 */
// Deep partial for settings updates — callers send only changed fields
// package-local
type DeepPartial<T> = { [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P] }

export async function updateUserSettingsDetailed(
  settings: DeepPartial<UserSettingsResponse>,
  idToken: string,
): Promise<void> {
  return secureFetch<void>(`${SECURE_API_BASE}/user/settings`, idToken, {
    method: 'PUT',
    body: JSON.stringify(settings),
  })
}
